import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Tabs,
  Row,
  Col,
  Card,
  Spin,
  Divider,
  Button,
  Input,
  Form,
  notification,
  message,
  Tooltip,
  Badge,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import { useDispatch, useSelector } from "react-redux";
import { ChatBoxModal } from "../../../../components/modal/chat-box-communication/ChatBoxModal";
import {
  buyerCampaigns,
  getCampaignsForPurchase,
  docuSignbyBuyer,
  docuSignCallback,
  docusignRefresh,
  updateProductsExpiryTimeDocusign,
} from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import { ReactComponent as CrossWithCircle } from "../../../../assests/cross-with-circle.svg";
import { ReactComponent as ProductChatIcon } from "../../../../assests/product-chat-icon.svg";
import { ReactComponent as InfoIcon } from "../../../../assests/info-icon.svg";
import { ReactComponent as SuccessIcon } from "../../../../assests/payment-success-icon.svg";
import { ReactComponent as SecuredIcon } from "../../../../assests/secure-icon.svg";
import "./IOSigning.css";
import "../../../../main.css";
import {
  formatDate,
  formatToUSCurrency,
  truncateDescriptionText,
  UTCtoISTConversion,
} from "../../../../components/common/utils/Utils";
import { ReactComponent as DownloadIconWithoutBorder } from "../../../../assests/download-icon-without-border.svg";
import {
  downloadInsertionOrder,
  getChatHistory,
} from "../../../../store/thunks/common-thunks/commonThunk";
import CampaignDetailsIO from "../../../../components/common/io/CampaignDetailsIO";
import { useMediaQuery } from "react-responsive";
import {
  ArrowLeftOutlined,
  BankOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  EditOutlined,
  FormOutlined,
  LockOutlined,
  MailOutlined,
  ReloadOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { ReactComponent as Warning } from "../../../../assests/emojione_warning.svg";
import { ReactComponent as Close } from "../../../../assests/close-x.svg";
import { useLocation, useNavigate } from "react-router-dom";
import AlertMessageModal from "../../../../components/modal/alert-message-modal/AlertMessageModal";
import {
  markProductAsRead,
  setCampaignInfoForChat,
  setIsChatModal,
  setIsProductInfo,
} from "../../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { clearLiveMsgNotificationForProduct } from "../../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";
import { Statistic, Typography } from "antd";
import "../../../../styles/GlobalStyle.css";
const IoSigning = ({
  isisIoSigning,
  isCustomTermsApplied,
  selectedRadio,
  handleStepChange,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isSmall = useMediaQuery({ maxWidth: 1440 });
  const [docuSignForm] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const [disableResend, setDisableResend] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [shouldScrollToSuccess, setShouldScrollToSuccess] = useState(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const subtitleRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [activeProduct, setActiveProduct] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedSignCamp, setSelectedSignCamp] = useState(null);
  const { Countdown } = Statistic;
  const { selectedCampaignDetails, buyerCampaignsLoader } = useSelector(
    (state) => state.buyerCampaigns,
  );
  const { isLiveMsgNotification } = useSelector((state) => state.webSocketMsgs);
  const { isChatModal } = useSelector(
    (state) => state.chatCommunicationHandleSlice,
  );
  const Text = Typography;
  const { user } = JSON.parse(localStorage.getItem("user"));
  const initialData = {
    signer_name: user?.firstName + " " + user?.lastName ?? "",
    signer_email: user?.email ?? "",
    forward_type: 1,
  };
  const { isLoading: checkoutCampaignsLoader, purchaseCampaign } = useSelector(
    (state) => state?.campaignpurchase,
  );
  const campaignNames = purchaseCampaign
    ?.map((campaign) => campaign?.name)
    ?.join(" · ");
  const [isExpiringSoon, setIsExpiringSoon] = useState(false);
  const expiryTime =
    purchaseCampaign?.[0]?.booking_array?.[0]?.reservation_expire_time?.date;
  const expiryTimestamp = expiryTime
    ? new Date(expiryTime.replace(" ", "T") + "Z").getTime()
    : null;
  const [isHoldExpired, setIsHoldExpired] = useState(false);

  const currentUserSession = user?.user_id;
  const reservationUserSession =
    purchaseCampaign?.[0]?.booking_array?.[0]?.reservation_user_session;
  const isOwnReservation = currentUserSession === reservationUserSession;
  // const isReservedByOtherUser =
  //   expiryTimestamp &&
  //   expiryTimestamp > Date.now() &&
  //   reservationUserSession &&
  //   !isOwnReservation;
  const [selectedForwardCampaign, setSelectedForwardCampaign] = useState(null);
  const { isLoading: pdfLoader, ioPdf } = useSelector(
    (state) => state.sellerCampaigns,
  );
  const { isDocuSignLoading, signedStatus } = useSelector(
    (state) => state.docuSign,
  );
  const [tabItems, setTabItems] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const [isWaitingForSignComplete, setIsWaitingForSignComplete] =
    useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const isLoading =
    buyerCampaignsLoader ||
    pdfLoader ||
    isDocuSignLoading ||
    checkoutCampaignsLoader;
  const agreementCardColumns = [
    {
      title: "Buyer",
      type: "[Sign Below]",
      termsType: (
        <div
          style={{
            borderBottom: "2px solid #000",
            width: "50%",
            display: "inline-block",
          }}
        ></div>
      ),
      buttonContent: "Sign below to complete",
      buttonColor: "transparent",
      textColor: "#935B00",
    },
    {
      title: "Seller",
      name: "Per User Agreement",
      termsType: "As per platform terms",
      buttonContent: "Per User Agreement",
      buttonColor: "transparent",
      textColor: "#D2042D",
    },
  ];

  const confirmCampaignContent = (
    <div className="launch-campaign-text" style={{ height: "100%" }}>
      <div className="launch-header">
        Confirm & Sign Your Insertion Order(IO)
      </div>
      <div className="launch-sub-header">
        Please review all details before signing. Once confirmed, this campaign
        will be active in your account. Any changes will require Advertising
        Marketplace team assistance.
        <br />
        <br />
        If you're not authorized to sign, forward this IO to the appropriate
        person using the details below by clicking on "Forward to Signatory"
        button.
      </div>
    </div>
  );

  const handleTabChange = useCallback(
    (key) => {
      setActiveKey(key);
      if (showInputs) setShowInputs(!showInputs);
      if (key) {
        dispatch(buyerCampaigns(key)).then((response) => {
          localStorage.setItem(
            "docusignCampaignEnvelopeId",
            response?.payload?.envelope_id,
          );
        });
      }
    },
    [dispatch],
  );

  const downloadIO = useCallback(
    (campaignDetails) => {
      if (campaignDetails?.id) {
        dispatch(downloadInsertionOrder(campaignDetails.id));
      }
    },
    [dispatch],
  );

  const getisDisabled = () => {
    if (
      initialData.signer_name == docuSignForm.getFieldValue("signer_name") &&
      initialData.signer_email == docuSignForm.getFieldValue("signer_email")
    )
      return true;
  };

  // Resending mail for docusign
  const handleResend = () => {
    const currentValues = {
      signer_name: selectedCampaignDetails?.docusign_signer_name || "",
      signer_email: selectedCampaignDetails?.docusign_signer_email || "",
    };
    docuSignForm.setFieldsValue(currentValues);
    setShowInputs(true);
  };

  // On clicking forward while submitting name and email
  const forwardDocuSignDetails = async () => {
    setShouldScrollToSuccess(true);
    try {
      localStorage.setItem(
        "docusignCampaignEnvelopeId",
        selectedCampaignDetails?.envelope_id,
      );
      const values = await docuSignForm.validateFields();
      let payload = {
        ...values,
        campaign_id: selectedForwardCampaign?.id,
        forward_type: 2,
      };

      dispatch(docuSignbyBuyer(payload)).then((response) => {
        if (response?.payload?.success) {
          setShowInputs(false);
          localStorage.setItem(
            "docusignCampaignEnvelopeId",
            selectedCampaignDetails?.envelope_id,
          );
          const email = docuSignForm.getFieldValue("signer_email");
          message.success(
            `Docusign link has been sent to ${email} successfully.`,
            10,
          );
          setActiveKey(selectedCampaignDetails?.id);
          docuSignForm.resetFields();
          dispatch(buyerCampaigns(selectedCampaignDetails?.id));
          dispatch(
            getCampaignsForPurchase({
              page_name: "docusign",
            }),
          );
        }
      });
    } catch (error) {
      console.log("validation failed", error);
    }
  };

  const handleChatClick = (product) => {
    const campaignId = String(selectedCampaignDetails?.id);
    const bookingId = String(product?.id);

    if (!campaignId || !bookingId) return;
    // store bookingId correctly
    setActiveProduct(bookingId);
    // mark as read
    dispatch(
      markProductAsRead({
        campaignId,
        productId: bookingId,
        readAt: Date.now(),
      }),
    );
    // clear live notifications for this product
    dispatch(
      clearLiveMsgNotificationForProduct({
        campaignId,
        productId: bookingId,
      }),
    );

    dispatch(getChatHistory({ campaignId, bookingId }));
    dispatch(setIsChatModal(true));
    dispatch(setIsProductInfo(product));
    dispatch(setCampaignInfoForChat(selectedCampaignDetails));

    if (isMobile) {
      navigate(`/buyer/chat/${campaignId}/${bookingId}`);
    }
  };

  useEffect(() => {
    if (!isChatModal || !activeProduct || !selectedCampaignDetails?.id) return;
    dispatch(
      markProductAsRead({
        campaignId: String(selectedCampaignDetails.id),
        productId: String(activeProduct),
        readAt: Date.now(),
      }),
    );
  }, [isChatModal, activeProduct, selectedCampaignDetails?.id, dispatch]);

  const productLiveStats = useMemo(() => {
    if (!activeKey) return {};

    const stats = isLiveMsgNotification.reduce((acc, msg) => {
      const campaignId = String(msg.campaignId);
      const bookingId = String(msg.bookingId);

      if (campaignId !== String(activeKey)) return acc;

      const msgTime = new Date(msg.timestamp).getTime();

      if (!acc[bookingId]) {
        acc[bookingId] = {
          count: 0,
          lastMessageTime: msgTime,
        };
      }

      acc[bookingId] = {
        count: acc[bookingId].count + 1,
        lastMessageTime: Math.max(acc[bookingId].lastMessageTime, msgTime),
      };

      return acc;
    }, {});

    return { ...stats };
  }, [isLiveMsgNotification, activeKey]);

  const renderTabContent = useCallback(() => {
    return (
      <div className="tab-content-scrollable">
        <Row
          className="tab-content-row"
          gutter={24}
          style={{ justifyContent: "center" }}
        >
          <Col xl={18} lg={18} sm={24} span={isMobile ? 24 : 18}>
            <div className="io-content-div">
              <Row gutter={[0, 24]}>
                <Col span={24}>
                  <Card className="io-overview-card default-font">
                    <div className="overview-content">
                      <div className="io-overview default-color">
                        Campaign Overview
                      </div>

                      {selectedCampaign?.docusign_sign_status != 1 ||
                        (!selectedCampaign?.docusign_sign_status && (
                          <div className="io-unsigned default-color">
                            <CrossWithCircle defaultColor="#D2042D" />
                            <div>Not Signed</div>
                          </div>
                        ))}
                    </div>

                    <Row gutter={[29, 29]} className="default-font">
                      <Col xl={5} sm={12} className="default-font">
                        <div className="campaign-label">
                          {selectedCampaignDetails?.cid}
                        </div>
                        <div className="campaign-value">
                          {selectedCampaignDetails?.name}
                        </div>
                      </Col>
                      <Col lg={5} sm={12} className="default-font">
                        <div className="campaign-label">Total Products</div>
                        <div className="campaign-value">
                          {selectedCampaignDetails?.products?.length ||
                            selectedCampaignDetails?.booking_array?.length ||
                            0}
                        </div>
                      </Col>
                      <Col lg={5} sm={12} className="default-font">
                        <div className="campaign-label">Start Date</div>
                        <div className="campaign-value">
                          {formatDate(
                            selectedCampaignDetails?.startDate ||
                              selectedCampaignDetails?.campaign_dates
                                ?.campaign_start_date,
                          )}
                        </div>
                      </Col>
                      <Col lg={5} sm={12} className="default-font">
                        <div className="campaign-label">End Date</div>
                        <div className="campaign-value">
                          {formatDate(
                            selectedCampaignDetails?.endDate ||
                              selectedCampaignDetails?.campaign_dates
                                ?.campaign_end_date,
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col span={24}>
                  <Card className="campaign-io-preview">
                    <Row>
                      <Col md={16} lg={20}>
                        <div className="io-doc default-color default-font">
                          Complete Insertion Order document
                        </div>
                        <div className="default-font launch-sub-header">
                          Review all terms, conditions, and product details
                          before signing
                        </div>
                      </Col>
                      <Col span={4}>
                        <Button
                          className="io-download-btn"
                          onClick={() => downloadIO(selectedCampaignDetails)}
                          loading={pdfLoader}
                        >
                          <DownloadIconWithoutBorder color="#000" />
                          {!isMobile && <span>Download IO</span>}
                        </Button>
                      </Col>
                    </Row>
                    <div className="io-preview-scrollable">
                      <CampaignDetailsIO
                        campaignDetails={selectedCampaignDetails}
                        isCheckoutPage={true}
                        pdfLoader={pdfLoader}
                        isIoSigning={true}
                        selectedRadio={selectedRadio}
                        isCustomTermsApplied={isCustomTermsApplied}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>

          {/* Commented Product chat for next release */}
          {/* {!isMobile && ( */}
          <Col xl={6} lg={6}>
            <div className="sticky-side-content">
              <Card>
                <div className="card-headings default-color default-font">
                  Product Chat
                </div>
                <div className="default-font chat-space">
                  Communicate with sellers directly for each ad space
                </div>
                <Row>
                  <Col className="product-headers" span={16}>
                    Products
                  </Col>
                  <Col className="product-headers" span={8} align="center">
                    Action
                  </Col>
                </Row>
                <Divider className="zero-padding-div" />
                {selectedCampaignDetails?.products?.map((product) => {
                  const bookingId = String(product.id);
                  const messageCount =
                    productLiveStats?.[bookingId]?.count || 0;
                  return (
                    <React.Fragment key={String(product.id)}>
                      <Row className="card-headings">
                        <Col span={16} className="default-font">
                          <Tooltip title={product?.title}>
                            <span className="product-title">
                              {truncateDescriptionText(product?.title)}
                            </span>
                          </Tooltip>
                          <div className="client-name">
                            {product?.client_name}
                          </div>
                        </Col>

                        <Col
                          span={8}
                          align="center"
                          className="default-font"
                          onClick={() => handleChatClick(product)}
                        >
                          <Badge
                            count={messageCount}
                            color="#d2042d"
                            size="small"
                          >
                            <ProductChatIcon className="chat-icon" />
                          </Badge>
                        </Col>
                      </Row>

                      <Divider className="zero-padding-div" />
                    </React.Fragment>
                  );
                })}
              </Card>
            </div>
          </Col>
          {/* )} */}
        </Row>

        {/* {isMobile && (
          <Row gutter={24} style={{ marginTop: 24 }}>
            <Col span={24}>
              <Card className="io-sign-mobile-card">
                <div className="default-color sign-io">
                  {" "}
                  Sign the IO to execute this agreement
                </div>
                <div className="terms-text">
                  In witness whereof, the parties, through their
                  representatives, have executed this Agreement.
                </div>
                <Row>
                  {agreementCardColumns.map((column, index) => {
                    return (
                      <Col span={24} className="default-font" key={index}>
                        <div className="agreement-title">{column.title}</div>
                        <div className="agreement-content">
                          By: {column.name}
                        </div>
                        <div className="agreement-content">
                          Date: {formatDate(new Date())}{" "}
                        </div>
                        <div className="agreement-content">
                          Its: {column.termsType}{" "}
                        </div>
                        <div
                          className="agreement-button-labels"
                          style={{ color: column.textColor }}
                        >
                          {column.buttonContent}
                        </div>
                        <Divider className="zero-padding" />
                      </Col>
                    );
                  })}
                </Row>
              </Card>
            </Col>
          </Row>
        )} */}
      </div>
    );
  }, [
    selectedCampaignDetails,
    productLiveStats,
    isMobile,
    pdfLoader,
    downloadIO,
  ]);

  const isExpired = (campaign) => {
    const expiryTime = campaign?.docusign_url_expiry
      ? UTCtoISTConversion(campaign.docusign_url_expiry)
      : null;

    if (!expiryTime) {
      return false;
    }
    return new Date() < expiryTime;
  };
  // On clicking continue to docusign
  const handleContinueClick = (event) => {
    if (showInputs) {
      setShowInputs(false);
      docuSignForm.resetFields();
    }
    setSelectedSignCamp(event);
    setOpenAlertModal(true);
    setIsWaitingForSignComplete(true);
    localStorage.setItem("waitingForDocusign", "true");
    localStorage.setItem(
      "docusignCampaignEnvelopeId",
      selectedCampaignDetails?.envelope_id,
    );
  };

  const openInNewTab = (url) => {
    // Method 1: Try window.open first
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");

    if (newWindow) {
      return; // Success
    }

    setTimeout(() => {
      notification.warning({
        key: "docusign-popup",
        message: "New Tab Required",
        description: (
          <div>
            <p>Please allow popups or </p>
            <a
              onClick={() => {
                notification.destroy("docusign-popup");
              }}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
            >
              click here to open DocuSign
            </a>
          </div>
        ),
        duration: 10,
      });
    }, 1000);

    return false;
  };

  // On clicking "proceed" in the alert modal when "Continue to Docusign" is clicked
  const onDocusignProceed = () => {
    const campaignId = selectedSignCamp?.id;
    let payload = { ...initialData, campaign_id: campaignId };
    setOpenAlertModal(false);
    dispatch(docuSignbyBuyer(payload)).then((response) => {
      if (response?.payload?.success) {
        localStorage.setItem(
          "docusignCampaignEnvelopeId",
          response?.payload?.envelopeId,
        );
        const docusignUrl =
          response?.payload?.signingUrl ||
          selectedCampaign?.docusign_url ||
          selectedCampaignDetails?.docusign_url;

        if (docusignUrl) {
          setTimeout(() => {
            openInNewTab(docusignUrl);
          }, 100);
        }
      }
    });
  };
  const handleSignComplete = useCallback(async () => {
    setIsWaitingForSignComplete(false);
    // Clear the waiting flag immediately
    localStorage.removeItem("waitingForDocusign");
    try {
      const envelopeId = localStorage.getItem("docusignCampaignEnvelopeId");
      if (envelopeId) {
        await dispatch(docuSignCallback(envelopeId)).then((result) => {
          if (result.payload == 1) {
            dispatch(
              getCampaignsForPurchase({
                page_name: "docusign",
              }),
            ).then((response) => {
              const updatedCampaigns = response.payload?.campaigns || [];
              if (updatedCampaigns.length == 0) {
                navigate("/buyer/io-signing/success");
              } else {
                message.success(
                  "Campaign signed successfully. Please continue with the remaining campaigns.",
                  3,
                );
                const nextCampaign = updatedCampaigns[0];
                if (nextCampaign) {
                  setActiveKey(nextCampaign?.id);
                  dispatch(buyerCampaigns(nextCampaign?.id));
                } else setActiveKey(null);
              }
            });
            window.history.replaceState(null, "", "/buyer/campaign-payment");
          }
        });
      } else {
        console.error("No envelopeId found for signature completion");
      }
    } catch (error) {
      console.error("Final API for sign failed", error);
    }
  }, [dispatch, navigate, selectedCampaignDetails]);

  // Adding window focus event to check docusign status
  useEffect(() => {
    const handleWindowFocus = () => {
      notification.destroy("docusign-popup");
      const isSigned = localStorage.getItem("signStatus");
      if (isSigned) {
        fetchingAllCampaigns();
        //localStorage.removeItem("signStatus"); //Commented this to avoid race condition where other tabs miss the success card after completing docusign of all campaigns
        localStorage.removeItem("docusignCampaignEnvelopeId");
      }
    };

    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [dispatch, handleSignComplete]);

  useEffect(() => {
    if (!expiryTimestamp) return;
    if (expiryTimestamp <= Date.now()) {
      setIsHoldExpired(true);
    } else {
      setIsHoldExpired(false);
    }
  }, [expiryTimestamp]);
  // Enhanced version of your existing useEffect
  useEffect(() => {
    const checkSigningComplete = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const signEvent = urlParams.get("event");
      const isWaiting = localStorage.getItem("waitingForDocusign") === "true";
      const envelopeId = localStorage.getItem("docusignCampaignEnvelopeId");

      if (signEvent === "signing_complete" && isWaiting && envelopeId) {
        // Immediate cleanup of URL
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        localStorage.setItem("signStatus", true);
        // Process the completion
        handleSignComplete();
      }
    };

    checkSigningComplete();
  }, [location.search, handleSignComplete]);
  // Refresh to fetch is docusign completed
  const refreshdocuSign = () => {
    const envelopeId = selectedCampaignDetails?.envelope_id;
    dispatch(docusignRefresh(envelopeId)).then((response) => {
      if (response.payload) {
        if (response.payload?.success) {
          message.success(response.payload?.message, 10);
          setActiveKey(null);
          fetchingAllCampaigns();
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            docuSignForm.resetFields();
          }, 100);
        } else message.error(response.payload?.error, 10);
      }
    });
  };

  const fetchingAllCampaigns = () => {
    dispatch(
      getCampaignsForPurchase({
        page_name: "docusign",
      }),
    ).then((response) => {
      const updatedCampaigns = response.payload?.campaigns ?? [];
      if (updatedCampaigns.length == 0) {
        navigate("/buyer/io-signing/success");
        return;
      }
      let firstCampaignId = response.payload.campaigns[0]?.id;
      setActiveKey(firstCampaignId);
      dispatch(buyerCampaigns(firstCampaignId));
    });
  };

  useEffect(() => {
    dispatch(
      getCampaignsForPurchase({
        page_name: "docusign",
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (purchaseCampaign?.length > 0) {
      setSelectedCampaign(
        purchaseCampaign?.find(
          (campaign) => campaign?.id == selectedCampaignDetails?.id,
        ),
      );
      const items = purchaseCampaign?.map((campaignItem) => ({
        key: String(campaignItem?.id),
        label: (
          <div>
            <div className="tab-header-id">
              {campaignItem?.cid}
              {selectedCampaign?.docusign_sign_status == 1 && (
                <span>
                  <CheckCircleOutlined />
                </span>
              )}
            </div>
            <div className="tab-header-name">{campaignItem.name}</div>
          </div>
        ),
        children: null,
      }));

      setTabItems(items);
      sessionStorage.setItem("isDocusign", true);
      const firstCampaignId = String(purchaseCampaign[0].id);
      if (!activeKey) {
        setActiveKey(firstCampaignId);
        dispatch(buyerCampaigns(firstCampaignId)).then((response) => {
          localStorage.setItem(
            "docusignCampaignEnvelopeId",
            response?.payload?.envelope_id,
          );
          setSelectedCampaign((prev) => ({
            ...prev,
            docusign_signer_name: response.payload.docusign_signer_name,
            docusign_signer_email: response.payload.docusign_signer_email,
            docusign_forward_type: 2,
          }));
        });
      }
    }
  }, [purchaseCampaign, activeKey, dispatch]);

  useEffect(() => {
    if (ioPdf && selectedCampaignDetails?.cid) {
      const url = window.URL.createObjectURL(ioPdf);
      const a = document.createElement("a");
      a.href = url;
      a.download = `IO-${selectedCampaignDetails.cid}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }, [ioPdf, selectedCampaignDetails]);

  useEffect(() => {
    if ((showInputs || shouldScrollToSuccess) && inputRef.current) {
      setTimeout(() => {
        inputRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
    }
  }, [showInputs, shouldScrollToSuccess]);

  useEffect(() => {
    if (selectedForwardCampaign && showInputs) {
      const currentValues = {
        signer_name: selectedForwardCampaign?.docusign_signer_name || "",
        signer_email: selectedForwardCampaign?.docusign_signer_email || "",
      };
      docuSignForm.setFieldsValue(currentValues);
    }
  }, [selectedForwardCampaign, showInputs, docuSignForm]);

  // Checking if the form is valid
  useEffect(() => {
    const checkFormValidity = () => {
      if (!docuSignForm) return;

      docuSignForm
        .validateFields(["signer_name", "signer_email"])
        .then(() => {
          setIsFormValid(true);
        })
        .catch(() => {
          setIsFormValid(false);
        });
    };

    // Check validity initially
    checkFormValidity();

    // Set up form value change listener
    const unsubscribe = docuSignForm?.watchFieldsValue?.();

    if (unsubscribe) {
      return unsubscribe;
    } else {
      // Fallback: check validity periodically
      const interval = setInterval(checkFormValidity, 300);
      return () => clearInterval(interval);
    }
  }, [docuSignForm]);

  useEffect(() => {
    const checkSigningComplete = () => {
      const urlParams = new URLSearchParams(location.search);
      const signEvent = urlParams.get("event");
      const isWaiting = localStorage.getItem("waitingForDocusign") === "true";

      if (signEvent === "signing_complete" && isWaiting) {
        handleSignComplete();

        // Clean up the URL
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    };

    checkSigningComplete();
  }, [location.search, handleSignComplete]); // Add handleSignComplete to dependencies

  // Scroll to top when component mounts or step changes
  useEffect(() => {
    // Scroll to top smoothly
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      // Fallback to window scroll
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [activeKey]);

  //  Scroll to success message card on submission of name and email
  useEffect(() => {
    if (
      selectedCampaignDetails?.docusign_forward_type == 2 &&
      selectedCampaignDetails.docusign_signer_name &&
      inputRef.current &&
      shouldScrollToSuccess
    ) {
      // Small delay to ensure the DOM has updated
      setTimeout(() => {
        inputRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
    }
  }, [
    selectedCampaignDetails?.docusign_forward_type,
    selectedCampaignDetails?.docusign_signer_name,
    shouldScrollToSuccess,
  ]);

  //  Triggers on page load
  useEffect(() => {
    setShowInputs(false);
  }, []);
  useEffect(() => {
    const element = subtitleRef.current;
    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  }, [campaignNames]);

  const getCampaignProducts = (campaign) => {
    return campaign?.products || campaign?.booking_array || [];
  };

  const getCampaignTotal = (campaign) => {
    const products = getCampaignProducts(campaign);

    return products.reduce((total, product) => {
      const amount =
        Number(
          String(
            product?.offerpriceperselectedDates ||
              product?.offerprice ||
              product?.negotiatedCost ||
              0,
          ).replace(/[$,]/g, ""),
        ) || 0;

      return total + amount;
    }, 0);
  };
  const hasCampaignHoldRequest = (campaign) => {
    const products = getCampaignProducts(campaign);
    if (!Array.isArray(products) || products.length === 0) {
      return false;
    }
    return products.some((product) => {
      if (
        !Object.prototype.hasOwnProperty.call(product, "hold_approval_status")
      ) {
        return false;
      }
      return (
        product?.hold_approval_status === 0 ||
        product?.hold_approval_status === 2
      );
    });
  };
  return (
    <div>
      <div
        className="io-container default-font redesigned-io-container"
        ref={containerRef}
      >
        {/* Main content area with scrolling */}
        <Text className="common-text-101828-18-600">
          Insertion Order Documents
        </Text>
        <div className="main-content-area">
          <div className={`${isMobile ? "" : "re-designed-container"}`}>
            <div className="sticky-header-section ">
              {/* 

              Commented Reservation mechanism
              
              {isHoldExpired ? (
                <div className="reservation-expired-banner">
                  <div className="reservation-expired-icon">
                    <WarningOutlined />
                  </div>
                  <div className="reservation-expired-content">
                    <div className="reservation-expired-title common-text-d2042d-14">
                      Your hold has expired
                    </div>
                    <div className="reservation-expired-text">
                      The 10-minute reservation on your ad spaces has ended.
                      These spaces may now be available to other buyers. Please
                      return to the campaign review and proceed quickly to
                      secure your booking.
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className={`reservation-banner ${isExpiringSoon ? "" : ""}`}
                  >
                    <div
                      className={`reservation-lock ${isExpiringSoon ? "" : ""}`}
                    >
                      <LockOutlined />
                    </div>
                    <div className="reservation-info">
                      <div
                        className={`reservation-title ${
                          isExpiringSoon ? "reservation-title-warning" : ""
                        }`}
                      >
                        <span className="common-text-92400E-14">
                          {isReservedByOtherUser
                            ? "⏳ Ad spaces are currently reserved by another buyer."
                            : "🔒 Ad spaces on hold for you"}
                        </span>
                      </div>
                      <Tooltip title={isTruncated ? campaignNames : null}>
                        <div
                          ref={subtitleRef}
                          className="reservation-subtitle location-grey-text-12"
                        >
                          {campaignNames}
                        </div>
                      </Tooltip>
                    </div>
                    <div className="reservation-timer-wrapper">
                      <div
                        className={`reservation-timer ${
                          isExpiringSoon ? "reservation-timer-warning" : ""
                        }`}
                      >
                        <div className="reservation-timer-content">
                          <ClockCircleOutlined />
                          <Countdown
                            value={expiryTimestamp}
                            format="mm:ss"
                            onFinish={() => {
                              setIsHoldExpired(true);
                            }}
                            valueStyle={{
                              color: "#FFFFFF",
                              fontSize: "28px",
                              fontWeight: 700,
                              lineHeight: 1,
                              marginBottom: 0,
                            }}
                            onChange={(value) => {
                              if (!value) {
                                return;
                              }
                              if (value <= 2 * 60 * 1000) {
                                setIsExpiringSoon(true);
                              } else {
                                setIsExpiringSoon(false);
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="reservation-timer-label grey-color-text-99a1af-11">
                        {isExpiringSoon ? (
                          <>
                            <Warning className="warning-icon" /> Expiring soon!
                          </>
                        ) : (
                          "remaining"
                        )}
                      </div>
                    </div>
                    <div className="reservation-status">
                      <div className="reservation-status-item">
                        <CheckCircleOutlined
                          style={{ width: "12px", height: "auto" }}
                        />
                        <span className="location-grey-text-12">
                          {isReservedByOtherUser
                            ? "Another buyer is completing the booking process"
                            : "Spaces locked for you only"}
                        </span>
                      </div>
                      <div className="reservation-status-item">
                        <CheckCircleOutlined
                          style={{ width: "12px", height: "auto" }}
                        />
                        <span className="location-grey-text-12">
                          {isReservedByOtherUser
                            ? "Waiting for reservation to expire or be released"
                            : "Sign the IO before time runs out"}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              )} 
              <div className="reservation-expired-banner">
                <SecuredIcon />
                <div className="reservation-expired-content">
                  <div className="reservation-expired-title common-text-d2042d-14">
                    <Text
                      className="common-action-items-text-grey-14"
                      style={{ textAlign: "start" }}
                    >
                      {
                        <span className="common-text-d2042d-14">
                          Secured by DocuSign ·
                        </span>
                      }{" "}
                      Sign your Buyer IO first. It is then{" "}
                      {
                        <span className="common-action-items-text-black-14">
                          automatically dispatched to all sellers
                        </span>
                      }{" "}
                      for their signatures. Once all parties have signed, the
                      campaign is considered{" "}
                      {
                        <span className="common-action-items-text-black-14">
                          purchased and active.
                        </span>
                      }
                    </Text>
                  </div>
                </div>
              </div>
              */}

              {/* <div className="io-header">
            Insertion Order (IO) Review & Signature
          </div>
          <p className="io-sub-header">
            Review your campaign details, discuss with sellers product-wise, and
            sign the IO to confirm your booking.
          </p>
          <Tabs
            className="io-tabs sticky-tabs"
            items={tabItems}
            activeKey={activeKey}
            onChange={handleTabChange}
          /> */}
            </div>

            {/* <div className="signing-progress-container common-card-styles">
              <div className="signing-progress-header">
                <Text className="common-text-101828-18">Signing Progress</Text>

                <Text className="signing-progress-count">0/3 signed</Text>
              </div>

              <div className="signing-process-status-bar"></div>

              <div className="signing-process-steps">
                <div className="signing-step">
                  <span className="signing-step-circle"></span>
                  <span className="location-grey-text-12">
                    You sign Buyer IO
                  </span>
                </div>

                <span className="signing-step-arrow">›</span>

                <div className="signing-step">
                  <span className="signing-step-circle"></span>
                  <span className="location-grey-text-12">
                    IOs auto-sent to sellers
                  </span>
                </div>

                <span className="signing-step-arrow">›</span>

                <div className="signing-step">
                  <span className="signing-step-circle"></span>
                  <span className="location-grey-text-12">
                    Sellers sign their IOs
                  </span>
                </div>

                <span className="signing-step-arrow">›</span>

                <div className="signing-step">
                  <span className="signing-step-circle"></span>
                  <span className="location-grey-text-12">
                    Campaign purchased &amp; active
                  </span>
                </div>
              </div>
            </div> */}

            <div className="insertion-order-documents ">
              {/* Buyer Summary IO */}
              {purchaseCampaign?.length > 0 ? (
                purchaseCampaign.map((campaign, index) => {
                  const products = getCampaignProducts(campaign);
                  const campaignTotal = getCampaignTotal(campaign);
                  const isSigned = campaign?.docusign_sign_status === 1;
                  return (
                    <div
                      className="io-document-card common-card-styles"
                      key={campaign?.id || campaign?._id || index}
                    >
                      {/* LEFT */}
                      <div className="io-document-left">
                        <div className="io-document-content">
                          <div className="common-text-101828-16">
                            {campaign?.name || "-"}
                          </div>
                          <div
                            className="io-document-tags"
                            style={{ marginTop: "8px" }}
                          >
                            {products.length > 0 ? (
                              products?.map((product, productIndex) => (
                                <span
                                  className="common-text-4a5565-12"
                                  key={
                                    product?.id || product?._id || productIndex
                                  }
                                >
                                  {product?.title || "-"}
                                </span>
                              ))
                            ) : (
                              <span className="common-text-4a5565-12">
                                No products
                              </span>
                            )}
                          </div>
                          <div
                            className="common-text-101828-14"
                            style={{ marginTop: "10px" }}
                          >
                            {formatToUSCurrency(campaignTotal)}
                          </div>
                        </div>
                      </div>
                      <div className="io-document-right">
                        {/* <span
                          className={`io-status ${
                            isSigned ? "signed" : "awaiting"
                          }`}
                        >
                          {isSigned ? "✓ Signed" : "◷ Awaiting Your Signature"}
                        </span> */}

                        <div className="io-actions">
                          <Button
                            className={`${
                              selectedCampaignDetails?.docusign_forward_type ==
                              2
                                ? "restrict-button"
                                : "forward-btn"
                            } `}
                            disabled={
                              selectedCampaignDetails?.docusign_forward_type ==
                              2
                            }
                            onClick={() => {
                              setSelectedForwardCampaign(campaign);
                              setShowInputs(true);
                              setShouldScrollToSuccess(true);
                            }}
                          >
                            <FormOutlined />
                            Forward to Signatory
                          </Button>

                          <Button
                            type="default"
                            className="io-download-btn common-action-items-text-grey"
                            // onClick={() => downloadIO(campaign)}
                            onClick={() => downloadIO(selectedCampaignDetails)}
                          >
                            <DownloadOutlined />
                            Download
                          </Button>

                          {!isSigned && (
                            <Button
                              type="primary"
                              className={`io-sign-btn common-text-FFFFFF-12 ${
                                isExpired(campaign) ? "restrict-button" : ""
                              }`}
                              disabled={isExpired(campaign)}
                              onClick={() => {
                                handleContinueClick(campaign);
                              }}
                            >
                              <EditOutlined />
                              Sign via DocuSign
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="io-document-card common-card-styles">
                  <span className="common-text-6A7282-14">
                    No Insertion Order documents available.
                  </span>
                </div>
              )}

              {showInputs &&
                selectedForwardCampaign &&
                selectedCampaign?.docusign_sign_status != 1 &&
                !selectedCampaign?.docusign_url && (
                  <div ref={inputRef}>
                    <Card
                      style={{ marginTop: "1rem" }}
                      className="common-card-styles card-body-style"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "16px",
                        }}
                      >
                        <div className="launch-header">
                          Enter the details of authorized signatory
                        </div>

                        <Close
                          className="forward-close-btn"
                          onClick={() => {
                            setShowInputs(false);
                            setSelectedForwardCampaign(null);
                            setShouldScrollToSuccess(false);
                            docuSignForm.resetFields();
                          }}
                        />
                      </div>

                      <div
                        style={{
                          marginBottom: "16px",
                          fontSize: "14px",
                          color: "#4A5565",
                        }}
                      >
                        Campaign:{" "}
                        <strong>{selectedForwardCampaign?.name || "-"}</strong>
                      </div>
                      <Form
                        form={docuSignForm}
                        name="userDetailsDocuSign"
                        validateTrigger={["onChange", "onBlur", "onSubmit"]}
                        onValuesChange={() => {
                          setTimeout(() => {
                            docuSignForm
                              .validateFields(["signer_name", "signer_email"])
                              .then(() => setIsFormValid(true))
                              .catch(() => setIsFormValid(false));
                          }, 0);
                        }}
                      >
                        <Row gutter={10}>
                          <Col span={isMobile ? 24 : 8}>
                            <Form.Item
                              name="signer_name"
                              label="Full Name"
                              validateTrigger={["onChange", "onBlur"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter signer's full name",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter name"
                                allowClear
                                className="user-name forward-camp-input"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={isMobile ? 24 : 8}>
                            <Form.Item
                              name="signer_email"
                              label="Email"
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter signer's email",
                                },
                                {
                                  type: "email",
                                  message: "Please enter valid email address",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter email"
                                allowClear
                                className="user-email forward-camp-input"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Tooltip
                              trigger={isMobile ? "click" : "hover"}
                              title={`${
                                !isFormValid
                                  ? "Please fill the details to proceed"
                                  : ""
                              }`}
                            >
                              <Button
                                disabled={
                                  !isFormValid ||
                                  isExpired(selectedForwardCampaign)
                                }
                                className={`docu-sign-buttons confirm-docusign ${
                                  !isFormValid ||
                                  isExpired(selectedForwardCampaign)
                                    ? "disable-button"
                                    : ""
                                }`}
                                onClick={forwardDocuSignDetails}
                              >
                                Forward
                              </Button>
                            </Tooltip>
                          </Col>
                        </Row>
                      </Form>
                    </Card>
                  </div>
                )}
              <Button
                type="default"
                className="back-review-btn common-text-6A7282-14"
                onClick={() => handleStepChange(0)}
              >
                <ArrowLeftOutlined />
                Back to Review
              </Button>
            </div>
          </div>
          <div className="order-summary-re-designed-div">
            <div className="signing-progress-container common-card-styles">
              <Text className="common-text-101828-18">Order Summary</Text>

              {/* Dynamic Campaign/Product Summary */}
              {purchaseCampaign?.length > 0 ? (
                purchaseCampaign.map((campaign, campaignIndex) => {
                  const products = getCampaignProducts(campaign);
                  const campaignTotal = getCampaignTotal(campaign);

                  return (
                    <React.Fragment
                      key={campaign?.id || campaign?._id || campaignIndex}
                    >
                      {/* Campaign Name */}
                      <div
                        style={{
                          marginTop: "12px",
                          marginBottom: "8px",
                        }}
                      >
                        <Text className="common-text-101828-18 ">
                          {campaign?.name || "-"}
                        </Text>
                      </div>

                      {/* Products */}
                      {products?.length > 0 ? (
                        products.map((product, productIndex) => {
                          const productAmount =
                            Number(
                              String(
                                product?.offerpriceperselectedDates ||
                                  product?.offerprice ||
                                  product?.negotiatedCost ||
                                  0,
                              ).replace(/[$,]/g, ""),
                            ) || 0;

                          return (
                            <div
                              key={product?.id || product?._id || productIndex}
                              className="re-designed-order-summary"
                            >
                              <div style={{ width: isSmall ? "100%" : "70%" }}>
                                <Tooltip title={product?.title}>
                                  <Text className="common-text-4a5565-12 truncate">
                                    {product?.title || "-"}
                                  </Text>
                                </Tooltip>
                              </div>
                              <div>
                                <Text className="common-text-101828-14">
                                  {formatToUSCurrency(productAmount)}
                                </Text>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <Text className="common-text-4a5565-12">
                          No products
                        </Text>
                      )}

                      {/* Campaign Total */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <Text className="common-text-101828-14">
                          Campaign Total
                        </Text>

                        <Text className="common-text-101828-14">
                          {formatToUSCurrency(campaignTotal)}
                        </Text>
                      </div>

                      {campaignIndex < purchaseCampaign.length - 1 && (
                        <div className="common-divider-horizontal" />
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <div style={{ marginTop: "10px" }}>
                  <Text className="common-text-4a5565-12">
                    No items available
                  </Text>
                </div>
              )}

              {/* Grand Total */}
              <div className="common-divider-horizontal" />

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Text className="common-text-101828-14">Total</Text>

                <Text className="common-text-color-red-14">
                  {formatToUSCurrency(
                    purchaseCampaign?.reduce(
                      (total, campaign) => total + getCampaignTotal(campaign),
                      0,
                    ) || 0,
                  )}
                </Text>
              </div>

              {/* Security Information */}
              <div
                className="reservation-status-item"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginTop: "5px",
                }}
              >
                <Row style={{ gap: "5px" }}>
                  <CheckCircleOutlined
                    style={{ width: "12px", height: "auto" }}
                  />
                  <span className="location-grey-text-12">
                    DocuSign secured
                  </span>
                </Row>

                <Row style={{ gap: "5px" }}>
                  <CheckCircleOutlined
                    style={{ width: "12px", height: "auto" }}
                  />
                  <span className="location-grey-text-12">
                    Auto-sent to sellers on sign
                  </span>
                </Row>

                <Row style={{ gap: "5px" }}>
                  <CheckCircleOutlined
                    style={{ width: "12px", height: "auto" }}
                  />
                  <span className="location-grey-text-12">
                    Campaign active once all sign
                  </span>
                </Row>
              </div>
            </div>
          </div>

          {/* <div className="main-content-inner">
            {activeKey && (
              <div className="tab-content-container">{renderTabContent()}</div>
            )}
          </div> */}
          {/* Docusign section */}
          {/* {selectedCampaignDetails && (
            <div className="docu-sign-section">
              <Col
                span={isMobile ? 24 : 18}
                className="docu-sign-option-container"
              >
                <Card>
                  <div className="card-headings default-color sign-header">
                    {" "}
                    Sign the IO to execute this agreement
                  </div>
                  <Card className="sign-card">
                    <div className="sign-sub-header default-font">
                      In witness whereof, the parties, through their
                      representatives, have executed this Agreement.
                    </div>
                    <Row gutter={[5, 10]}>
                      {agreementCardColumns.map((column, index) => (
                        <Col
                          span={isMobile ? 24 : 12}
                          className="default-font"
                          key={index}
                        >
                          <div className="agreement-title">{column.title}</div>
                          <div className="agreement-content">
                            By: {column.name}
                          </div>
                          <div className="agreement-content">
                            Date: {formatDate(new Date())}{" "}
                          </div>
                          <div className="agreement-content">
                            Its: {column.termsType}{" "}
                          </div>
                          <div className="signed-label">
                            <Button
                              className="agreement-button-labels"
                              style={{
                                background: column.buttonColor,
                                color: column.textColor,
                              }}
                            >
                              {column.buttonContent}
                            </Button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Card>
                </Card>

                <div className="io-footer">
                  {confirmCampaignContent}
                  <div className="docusign-buttons" style={{ display: "flex" }}>
                    <Tooltip
                      trigger={isMobile ? "click" : "hover"}
                      title={
                        isReservedByOtherUser
                          ? "This ad space is currently reserved by another buyer. Please wait until the reservation expires."
                          : null
                      }
                    >
                      <Button
                        className={`${
                          selectedCampaignDetails?.docusign_forward_type == 2
                            ? "restrict-button"
                            : "forward-btn"
                        } `}
                        disabled={
                          selectedCampaignDetails?.docusign_forward_type == 2 ||
                          isReservedByOtherUser ||
                          isHoldRequested
                        }
                        onClick={() => {
                          setShowInputs(true);
                          setShouldScrollToSuccess(true);
                        }}
                      >
                        <FormOutlined />
                        Forward to Signatory
                      </Button>
                    </Tooltip>
                    {selectedCampaignDetails?.docusign_forward_type != 2 && (
                      <Tooltip
                        trigger={isMobile ? "click" : "hover"}
                        title={
                          isReservedByOtherUser
                            ? "This ad space is currently reserved by another buyer. Please wait until the reservation expires."
                            : null
                        }
                      >
                        <Button
                          className={`docu-sign-buttons continue-btn ${
                            isReservedByOtherUser || isHoldRequested
                              ? "disable-button"
                              : ""
                          }`}
                          onClick={handleContinueClick}
                          disabled={isReservedByOtherUser || isHoldRequested}
                        >
                          <FormOutlined />
                          Continue to Docusign
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </div>
                {selectedCampaignDetails?.docusign_forward_type == 2 &&
                  selectedCampaignDetails.docusign_signer_name && (
                    <Card ref={inputRef} className="io-mail-success-text">
                      <div className="docusign-refresh-section">
                        <div className="docusign-submitted-response">
                          <SuccessIcon
                            className={`${isMobile ? "icon-align" : ""}`}
                          />
                          <span>
                            The IO has been forwarded to{" "}
                            <span className="docu-signer">
                              {
                                selectedCampaignDetails.docusign_signer_name
                              }{" "}
                            </span>{" "}
                            at
                            <span className="docu-signer">
                              {" "}
                              {selectedCampaignDetails.docusign_signer_email}
                              .{" "}
                            </span>{" "}
                            They will receive signing instructions shortly.
                          </span>
                          <div className="docu-sign-mail-action-btns">
                            <Tooltip
                              title={
                                !isExpired() || disableResend
                                  ? "Docusign link has been shared to mail successfully.Please wait for 5mins for resending mail"
                                  : null
                              }
                            >
                              <Button
                                className="resend-btn"
                                onClick={handleResend}
                                disabled={!isExpired() || disableResend}
                              >
                                <MailOutlined />
                                Resend
                              </Button>
                            </Tooltip>
                            <Button
                              className="refresh-btn"
                              onClick={refreshdocuSign}
                            >
                              <ReloadOutlined />
                              Refresh
                            </Button>
                          </div>
                        </div>
                        <div>
                          {!isDocuSignLoading && signedStatus?.error && (
                            <div className="error-message">
                              {signedStatus.error}
                            </div>
                          )}
                        </div>
                      </div>
                    </Card>
                  )}

                {showInputs &&
                  selectedCampaign?.docusign_sign_status != 1 &&
                  !selectedCampaign?.docusign_url && (
                    <div ref={inputRef}>
                      <Card style={{ marginTop: "1rem" }}>
                        <div className="launch-header">
                          Enter the details of authorized signatory
                        </div>
                        <Form
                          form={docuSignForm}
                          name="userDetailsDocuSign"
                          validateTrigger={["onChange", "onBlur", "onSubmit"]}
                          onValuesChange={() => {

                            setTimeout(() => {
                              docuSignForm
                                .validateFields(["signer_name", "signer_email"])
                                .then(() => setIsFormValid(true))
                                .catch(() => setIsFormValid(false));
                            }, 0);
                          }}
                        >
                          <Row gutter={10}>
                            <Col span={isMobile ? 24 : 8}>
                              <Form.Item
                                name="signer_name"
                                label="Full Name"
                                validateTrigger={["onChange", "onBlur"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter signer's full name",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter name"
                                  allowClear
                                  className="user-name"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={isMobile ? 24 : 8}>
                              <Form.Item
                                name="signer_email"
                                label="Email"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter signer's email",
                                  },
                                  {
                                    type: "email",
                                    message: "Please enter valid email address",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter email"
                                  allowClear
                                  className="user-email"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Tooltip
                                trigger={isMobile ? "click" : "hover"}
                                title={`${
                                  !isFormValid
                                    ? "Please fill the details to proceed"
                                    : ""
                                }`}
                              >
                                <Button
                                  disabled={!isFormValid}
                                  className={`docu-sign-buttons confirm-docusign ${
                                    !isFormValid ? "disable-button" : ""
                                  }`}
                                  onClick={forwardDocuSignDetails}
                                >
                                  Forward
                                </Button>
                              </Tooltip>
                            </Col>
                            <Col></Col>
                          </Row>
                        </Form>
                      </Card>
                    </div>
                  )}
              </Col>
            </div>
          )} */}
          {openAlertModal && (
            <AlertMessageModal
              openAlertModal={openAlertModal}
              okButtonText={"Proceed"}
              onConfirm={onDocusignProceed}
              onCancel={() => setOpenAlertModal(false)}
              isClosable={true}
              descriptionText={
                <span>
                  <InfoIcon style={{ position: "relative", top: "5px" }} /> You
                  will be redirected to DocuSign portal. The session will remain
                  active for 5 minutes. Please complete your signature before it
                  expires. If the session expires, click 'Continue to DocuSign'
                  to restart the process.
                </span>
              }
            />
          )}
        </div>
        {!isMobile && <ChatBoxModal canvasWidth={620} />}

        {isLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </div>
    </div>
    // </div>
  );
};

export default IoSigning;
